import React from "react";
import {FormControl, InputLabel, MenuItem, Select, TextField} from "@mui/material";
import {UserInputSettings} from "./components/user-input-settings";
import {fieldSx} from "../editMenuStyles";
import {SubSectionHeader} from "../components/EditMenuSection";

export const ChoiceSettings = ({node, project, onUpdate, onChangeData}) => (
    <>
        <SubSectionHeader title="Source"/>
        <TextField
            value={node?.data?.options || ""}
            size="small"
            label="Options"
            placeholder="${global.[variable_name]}"
            helperText="Please enter a variable name that includes options."
            sx={fieldSx}
            onChange={(e) => onChangeData("options", e.target.value || "")}
            onBlur={() => onUpdate(node)}
        />

        <SubSectionHeader title="Parameter"/>
        <FormControl size="small" fullWidth sx={fieldSx}>
            <InputLabel id="choice-entity-select-label">Parameter Entity</InputLabel>
            <Select
                labelId="choice-entity-select-label"
                value={node?.data?.parameter?.entity_type}
                label="Parameter Entity"
                onChange={(e) => onChangeData("parameter", {
                    entity_type: e.target.value,
                    name: node?.data?.parameter?.name || "",
                })}
                onBlur={() => onUpdate(node)}
            >
                <MenuItem value=""><em>None</em></MenuItem>
                {project?.entities?.map(entity => (
                    <MenuItem key={entity?.id} value={entity?.name}>{entity?.name}</MenuItem>
                ))}
            </Select>
        </FormControl>
        <TextField
            value={node?.data?.parameter?.name || ""}
            size="small"
            label="Parameter name"
            placeholder="Enter the name of the parameter"
            helperText="With this name you will be able to further access the variable."
            sx={fieldSx}
            onChange={(e) => onChangeData("parameter", {
                entity_type: node?.data?.parameter?.entity_type || "",
                name: e.target.value || "",
            })}
            onBlur={() => onUpdate(node)}
        />
        <UserInputSettings node={node} onUpdate={onUpdate} onChangeData={onChangeData}/>
    </>
);
